import { createSlice } from '@reduxjs/toolkit';
import { getTenantDetail } from './tenantDetailAction';

export const tenantDetailSlice = createSlice({
  name: 'tenantDetail',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTenantDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTenantDetail.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getTenantDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
